import React from 'react';

// Helpers
import DOMPurify from 'dompurify';

export default function RawHTML({ html }) {
  return (<div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(html) }} />);
}